<template>
  <modal :show="show" showLarge>
    <div slot="modalHeader">
      <modal-header :closeModal="close">Review Link History</modal-header>
    </div>
    <spinner-icon v-if="loading" />
    <hr />
    <review-link-history-table :tableData="historyData" />
    <div slot="modalFooter">
      <modal-footer cancelText="Close" :closeModal="close" hideConfirmText/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'

import CreativeTable from '@/components/CreativeTable/creative-table'
import ReviewLinkHistoryTable from '@/components/Modal/links/components/review-link-history-table'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'

import Notifications from '@/components/Notifications/notifications'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'

import {notificationMixin} from '@/mixins/notificationMixin'

const NOTIFICATION_DELAY = 15000

export default {
  name: 'modal-review-link-history',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    CreativeTable,
    ReviewLinkHistoryTable,
    SpinnerIcon,
    Notifications
  },
  props: {
    show: Boolean,
    creativeId: String
  },
  data: () => ({
    polling: {
      time: 10000
    },
    historyData: []
  }),
  mounted () {
    this.startLoading()
    this.getReviewLinkHistory(this.creativeId).then(response => {
      this.finishLoading()
      if (response.success === false) {
        const notification = this.addNotification('danger', response.reason)
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, NOTIFICATION_DELAY) // Wait 15 second to remove the notification
        this.close()
        return
      }
      this.historyData = response.data
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Modal/links/modal-review-link-history.vue